export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[520px] items-center overflow-hidden bg-foreground-950 md:min-h-[620px]">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20stylized%20anime%20manga%20illustration%20of%20a%20romantic%20couple%20silhouettes%20facing%20each%20other%20surrounded%20by%20floating%20glowing%20pink%20hearts%20and%20golden%20sparkles%2C%20warm%20coral%20and%20gold%20color%20palette%2C%20soft%20dreamy%20gradient%20background%2C%20playful%20romantic%20webtoon%20cover%20art%20style%2C%20clean%20composition%2C%20high%20detail%2C%20warm%20golden%20hour%20lighting%2C%20no%20text&width=1600&height=900&seq=lovecomic-hero&orientation=landscape"
        alt="恋爱辅助器漫画浪漫风格主题插画，情侣剪影与飘浮爱心"
        className="absolute inset-0 h-full w-full object-cover object-center opacity-60"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/75"></div>

      {/* 漂浮装饰爱心 */}
      <i className="ri-heart-3-fill animate-floaty absolute left-[8%] top-24 text-3xl text-primary-400/70"></i>
      <i className="ri-heart-fill animate-floaty absolute right-[10%] top-32 text-2xl text-accent-400/70" style={{ animationDelay: "1s" }}></i>
      <i className="ri-sparkling-2-fill animate-floaty absolute right-[22%] bottom-24 text-2xl text-accent-300/70" style={{ animationDelay: "2s" }}></i>
      <i className="ri-sparkling-line animate-floaty absolute left-[20%] bottom-28 text-xl text-primary-300/60" style={{ animationDelay: "0.6s" }}></i>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-24 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-400/20 px-4 py-1.5 text-sm text-accent-200 ring-1 ring-accent-400/40">
            <i className="ri-heart-pulse-line"></i>
            浪漫治愈系 · 恋爱系统漫画
          </span>
          <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
            恋爱辅助器漫画<span className="text-accent-300">是什么</span>
          </h1>
          <p className="mt-5 text-base leading-relaxed text-background-200 md:text-lg">
            一段关于「恋爱辅助器」的奇遇——当内向的主角被神秘系统绑定，
            心动值、好感度与限时任务接连登场。这里为你一次讲清它的设定、系统机制、剧情走向与世界观。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#intro"
              className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-center text-base font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              开始了解这部漫画
            </a>
            <a
              href="#plot"
              className="whitespace-nowrap rounded-full bg-background-50/15 px-7 py-3 text-center text-base font-medium text-background-50 ring-1 ring-background-50/40 transition-colors hover:bg-background-50/25"
            >
              查看剧情梗概
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}